import { MultiChoiceQuestion } from './multi-choice-question';
import { Step } from '../../course/step';

export class StepExamMultiChoice extends Step {
  public qtyOfQuestions?: number;
  public guessingCorrection?: boolean;
  public shuffleQuestions?: boolean;
  public questions?: MultiChoiceQuestion[];
}
